/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Imageuploadformats2Inputs */

const en_imageuploadformats2 = /** @type {(inputs: Imageuploadformats2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JPEG, PNG or WebP`)
};

const de_imageuploadformats2 = /** @type {(inputs: Imageuploadformats2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JPEG, PNG oder WebP`)
};

/**
* | output |
* | --- |
* | "JPEG, PNG or WebP" |
*
* @param {Imageuploadformats2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const imageuploadformats2 = /** @type {((inputs?: Imageuploadformats2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Imageuploadformats2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_imageuploadformats2(inputs)
	return de_imageuploadformats2(inputs)
});
export { imageuploadformats2 as "imageUploadFormats" }